import { cookieStorage } from '@/services/cookie';
import useOnWindowFocus from '@/hooks/useWindowFocus';
import { useEffect, useState } from 'react';

const useCartItems = (trigger?: any) => {
  const [cartItems, setCartItems] = useState<number>(0);
  const { isWindowFocused } = useOnWindowFocus();

  const getCartItems = async () => {
    const { data } = await cookieStorage.get('cartItems');
    setCartItems(Number(data));
  };

  useEffect(() => {
    if (isWindowFocused) {
      getCartItems();
    }
  }, [isWindowFocused, trigger]);

  return { cartItems };
};

export default useCartItems;
